import { ConvexError } from 'convex/values'

import type { PhotoAsk } from './habitDots'

// Photo dots: one private photo per habit per logical day, offered after a
// check-in. Files are stored at PHOTO_PX square JPEG (habitPhotosNode).

export const PHOTO_PX = 512
export const PHOTO_MAX_UPLOAD_BYTES = 15 * 1024 * 1024
export const PHOTO_MAX_STORED_BYTES = 2 * 1024 * 1024
export const PHOTO_CAPTION_MAX = 140
export const VIDEO_MAX_BYTES = 15 * 1024 * 1024
export const VIDEO_MAX_SECONDS = 5
// The photo list for a habit covers about a year of days.
export const PHOTO_WINDOW_DAYS = 371
// Days a photo can still be added for (today and a few back, for late check-ins).
export const PHOTO_BACKFILL_DAYS = 3

export type PhotoErrorCode = 'notFound' | 'badImage' | 'badVideo' | 'badDay' | 'tooLarge'
export const photoError = (code: PhotoErrorCode) =>
  new ConvexError<{ kind: 'habitPhotos'; code: PhotoErrorCode }>({ kind: 'habitPhotos', code })

export const isDayKey = (s: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(s) && !Number.isNaN(Date.parse(`${s}T00:00:00Z`))

export const cleanCaption = (c: string | undefined) =>
  c?.trim().slice(0, PHOTO_CAPTION_MAX) || undefined

// "Sometimes" stays gentle: at most one ask a day, and after two dismissals in
// a row it rests for a fortnight (adding any photo clears the count).
export const PHOTO_REST_DAYS = 14
export const PHOTO_DISMISS_LIMIT = 2

const dayNumber = (key: string) => Math.floor(Date.parse(`${key}T00:00:00Z`) / 86_400_000)

export function shouldAskForPhoto(
  ask: PhotoAsk | undefined,
  state: { lastAsked: string; dismissed: number } | undefined,
  today: string,
  hasPhotoToday: boolean,
): boolean {
  if (hasPhotoToday || ask === 'never') return false
  if (ask === 'always') return true
  if (!state) return true
  if (state.lastAsked === today) return false
  if (state.dismissed < PHOTO_DISMISS_LIMIT) return true
  return dayNumber(today) - dayNumber(state.lastAsked) >= PHOTO_REST_DAYS
}
